const borderWidths = {
  px: "1px",
}

export default borderWidths
